// UnclaimedSearch.js (palette-matched to your reference, with Collabbay accent)
import React, { useEffect, useMemo, useState } from 'react';
import {
  ActivityIndicator,
  SafeAreaView,
  StyleSheet,
  View,
  Text,
  ScrollView,
  Linking,
  TextInput,
  TouchableOpacity,
  Modal,
  Platform
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { LinearGradient } from 'expo-linear-gradient';

const THEME = {
  // Cream canvas + deep pine chrome + Collabbay yellow accent
  canvas:   '#F4F6F1',     // page background (creamy)
  surface:  '#FFFFFF',     // cards
  subtle:   '#EEF0EA',     // light surface (chips / search)
  line:     '#D8DED2',     // borders
  text:     '#0B1F17',     // primary text (very dark green)
  textMut:  '#222',     // muted text
  pine:     'black',     // deep green for header and outlines
  pine2:    'black',     // mid green
  accent:   '#FFDF0D',     // Collabbay brand
  accentLine: '#E6D84F',
  // OPTIONAL – to match the dribbble lilac/coral accents, uncomment:
  // lilac:    '#B9A7FF',
  // coral:    '#F6A9B1',
};



function Typewriter({ words = [], speed = 80, erase = 60, pause = 900 }) {
  const [i, setI] = useState(0);          // which word
  const [txt, setTxt] = useState('');     // current text
  const [del, setDel] = useState(false);  // deleting?

  useEffect(() => {
    const current = words[i % words.length] || '';
    const step = () => {
      if (!del) {
        const next = current.slice(0, txt.length + 1);
        setTxt(next);
        if (next === current) {
          setTimeout(() => setDel(true), pause);
          return;
        }
      } else {
        const next = current.slice(0, txt.length - 1);
        setTxt(next);
        if (next.length === 0) {
          setDel(false);
          setI((i + 1) % words.length);
        }
      }
    };
    const t = setTimeout(step, del ? erase : speed);
    return () => clearTimeout(t);
  }, [txt, del, i, words, speed, erase, pause]);

  return (
    <Text style={styles.typeText}>
      {txt || ' '}
      <Text style={styles.caret}>|</Text>
    </Text>
  );
}


export default function UnclaimedSearch({ navigation }) {
  const [q, setQ] = useState('');
  const [mode, setMode] = useState('name'); // 'name' | 'location'
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);

  const [activeVenue, setActiveVenue] = useState(null);
  const [dt, setDt] = useState('');
  const [showDateModal, setShowDateModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);



const [featured, setFeatured] = useState([]);
const [loadingFeatured, setLoadingFeatured] = useState(false);
const featuredRef = React.useRef(null);
const featuredIndexRef = React.useRef(0);
const FEATURED_CARD_WIDTH = 220; // px
const FEATURED_GAP = 12;         // px


const [featured2, setFeatured2] = useState([]);
const [loadingFeatured2, setLoadingFeatured2] = useState(false);
const featuredRef2 = React.useRef(null);
const featuredIndexRef2 = React.useRef(0);


async function fetchFeatured(limit = 20) {
  try {
    setLoadingFeatured(true);
    const r = await fetch(`https://collabbay.com/APIControllers/GetFeaturedUnclaimed.php?limit=${limit}`, {
      credentials: 'include'
    });
    const d = await r.json();
    if (d?.ok && Array.isArray(d.results)) setFeatured(d.results);
    else setFeatured([]);
  } catch {
    setFeatured([]);
  } finally {
    setLoadingFeatured(false);
  }
}


async function fetchFeatured2(limit = 20) {
  try {
    setLoadingFeatured2(true);
    const r = await fetch(`https://collabbay.com/APIControllers/GetFeaturedUnclaimed.php?limit=${limit}`, {
      credentials: 'include'
    });
    const d = await r.json();
    setFeatured2(d?.ok && Array.isArray(d.results) ? d.results : []);
  } catch {
    setFeatured2([]);
  } finally {
    setLoadingFeatured2(false);
  }
}

useEffect(() => {
  if (!loading && results.length === 0) {
    fetchFeatured(20);
    fetchFeatured2(20); // ← add this line
  }
}, [loading, results.length]);

useEffect(() => {
  if (!featured2 || featured2.length === 0) return;
  const n = featured2.length;
  const id = setInterval(() => {
    featuredIndexRef2.current = (featuredIndexRef2.current - 1 + n) % n; // reverse
    const x = featuredIndexRef2.current * (FEATURED_CARD_WIDTH + FEATURED_GAP);
    if (featuredRef2.current?.scrollTo) {
      featuredRef2.current.scrollTo({ x, y: 0, animated: true });
    }
  }, 3000);
  return () => clearInterval(id);
}, [featured2]);


useEffect(() => {
  if (!loading && results.length === 0) {
    fetchFeatured(20);
  }
}, [loading, results.length]);


useEffect(() => {
  if (!featured || featured.length === 0) return;
  const interval = setInterval(() => {
    const n = featured.length;
    featuredIndexRef.current = (featuredIndexRef.current + 1) % n;
    const x = featuredIndexRef.current * (FEATURED_CARD_WIDTH + FEATURED_GAP);
    if (featuredRef.current?.scrollTo) {
      featuredRef.current.scrollTo({ x, y: 0, animated: true });
    }
  }, 3000);
  return () => clearInterval(interval);
}, [featured]);



  useEffect(() => {
    fetch('https://collabbay.com/APIControllers/GetSessionData.php', { credentials: 'include' })
      .then(r => r.json())
      .then(d => setUser(d || null))
      .catch(() => setUser(null));
  }, []);

  useEffect(() => {
    const id = setTimeout(() => {
      if (!q || q.trim().length < 2) { setResults([]); return; }
      setLoading(true);
      fetch('https://collabbay.com/APIControllers/SearchUnclaimedVenues.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ q: q.trim(), mode, limit: 40, offset: 0 }),
      })
        .then(r => r.json())
        .then(d => setResults(Array.isArray(d?.results) ? d.results : []))
        .catch(() => setResults([]))
        .finally(() => setLoading(false));
    }, 280);
    return () => clearTimeout(id);
  }, [q, mode]);


const emailTemplates = useMemo(() => ([

  
  (username, iso, venue) => `Hi ${venue.Name} team,

I’m ${username}, a London-based creator, and I’d love to come by on ${prettyHuman(iso)} for a collaboration. The idea would be to capture engaging content that highlights what makes your venue special — from your signature dishes to the atmosphere and overall experience.

I organise all of my collaborations through a tool called Collabbay. It keeps things straightforward for venues: bookings are confirmed in one place, reminders go out automatically so nothing gets missed, and deliverables are tracked clearly. It’s already used by over 500 creators with a combined reach of 21 million.

The whole point is to make collaborations quicker, more secure, and less hassle for you.

You can see how it works here:  
https://collabbayadmin.com/FindOut

Best,  
${username}`,

  (username, iso, venue) => `Hello ${venue.Name},

I’m ${username}. I’d like to propose a collaboration with a visit on ${prettyHuman(iso)}. I’ll create short-form content during the visit and share drafts promptly so you know what will be published.

To make the process smooth, I use Collabbay. It’s a platform that venues find helpful because it keeps everything in one place: booking confirmation, automatic reminders, and a log of agreed deliverables. More than 500 creators (21M combined reach) are already on it, which makes the process familiar and reliable.

It just makes working together easier.

More info for venues:  
https://collabbayadmin.com/FindOut

Thanks,  
${username}`,

  (username, iso, venue) => `Hi ${venue.Name},

I’m ${username}, and I’d love to feature your venue with a collaboration. I’m proposing ${prettyHuman(iso)} for the visit. I’ll agree the deliverables with you in advance (e.g. reel + stills), so everything is clear from the start.

I run my collabs through Collabbay. It keeps things secure and transparent: bookings are confirmed in one step, reminders go out automatically, and there’s a shared record of what content is due. It’s already trusted by 500+ creators with a combined reach of 21 million.

That way, you don’t have to worry about admin — everything is tracked and professional.

Learn more here:  
https://collabbayadmin.com/FindOut

Best regards,  
${username}`,

  (username, iso, venue) => `Hey ${venue.Name},

I’m ${username}, a content creator, and I’d love to collaborate with you. Would ${prettyHuman(iso)} work for a visit? I’ll capture content that shows off your space and helps bring more awareness to new audiences.

To make collaborations easier for venues, I use Collabbay. It’s a simple system that confirms bookings, sends reminders so nothing slips, and keeps a clear checklist of deliverables. Over 500 creators with 21M reach already rely on it.

It just makes the whole process smoother and more secure.

Details here:  
https://collabbayadmin.com/FindOut

Cheers,  
${username}`,

  (username, iso, venue) => `Hi ${venue.Name} team,

I’m ${username}. I’d love to propose a collab on ${prettyHuman(iso)}. I’ll create content that’s aligned with your brand and can help increase awareness.

I use Collabbay to keep everything professional and simple. It confirms the booking in one place, sends automated reminders, and tracks deliverables so expectations are always clear. With 500+ creators and a combined reach of 21 million using it, the process is well-established and reliable.

It saves time, reduces confusion, and makes sure both sides get what they need.

Here’s more info:  
https://collabbayadmin.com/FindOut

Thanks,  
${username}`,

]), []);




  function randomTemplate(){ return emailTemplates[Math.floor(Math.random()*emailTemplates.length)]; }
  function prettyHuman(iso){
    if(!iso) return '(date/time)';
    const d = new Date(iso); if (isNaN(d)) return iso;
    const day=d.getDate(), month=d.toLocaleString('default',{month:'long'});
    const h=d.getHours()%12||12, m=String(d.getMinutes()).padStart(2,'0'), ap=d.getHours()>=12?'PM':'AM';
    return `${day} ${month} ${h}:${m}${ap}`;
  }
  function openMailto(venue){
    const username = user?.Username || 'a creator';
    const subject = `Collab request for ${venue.Name} — ${prettyHuman(dt)}`;
const ig = (user && user.PlatformUsername)
  ? `\n\nInstagram: @${String(user.PlatformUsername).replace(/^@+/, '')}${user && user.PlatformFollowers ? ` (${user.PlatformFollowers} followers)` : ''}`
  : '';
const body = randomTemplate()(username, dt, venue) + ig;

    const url = `mailto:${encodeURIComponent(venue.Email||'')}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}&bcc=${encodeURIComponent('collabbaycloud@gmail.com')}`;
    Linking.openURL(url);
  }
  function awardCreds(amount=50){
    fetch('https://collabbay.com/APIControllers/AwardCreatorCreds.php', {
      method:'POST', headers:{'Content-Type':'application/json'}, credentials:'include',
      body: JSON.stringify({ amount, reason:'unclaimed-venue-outreach' }),
    }).catch(()=>{});
  }

  function onRequest(v){ setActiveVenue(v); setDt(''); setShowDateModal(true); }
  function onContinue(){ if(!dt) return; setShowDateModal(false); setShowConfirmModal(true); }
  function onConfirmSend(){ if(!activeVenue) return; openMailto(activeVenue); awardCreds(50); setShowConfirmModal(false); setActiveVenue(null); }

  return (
    <View style={{ flex:1,  backgroundColor: '#FFFFFF'}}>
<SafeAreaView style={{ flex: 1, backgroundColor: '#FFFFFF', maxWidth: 600, alignSelf: 'center', width: '100%' }}>

        {/* Hero header like the reference */}
        <LinearGradient
  colors={['#000000', '#FDF05D']}   // black → Collabbay yellow
          start={{x:0, y:0}} end={{x:1, y:1}}
          style={styles.hero}
        >
          <View style={styles.heroTop}>
            <TouchableOpacity style={styles.backBtn} onPress={() => navigation.goBack()}>
              <Ionicons name="arrow-back" size={20} color={THEME.pine} />
            </TouchableOpacity>
            {user?.Username ? (
              <View style={styles.loginPill}><Text style={styles.loginPillText}>Where to <Text style={{fontWeight:'800'}}>{user.Username}</Text>? ✨</Text></View>
            ) : (
              <TouchableOpacity style={styles.loginBtn} onPress={() => navigation.navigate('LogInPage')}>
                <Text style={styles.loginBtnText}>Log in</Text>
              </TouchableOpacity>
            )}
          </View>

      <View style={styles.typeLine}>
  <Text style={styles.heroSubStatic}>Search 1,000+ London</Text>
  <Typewriter
    words={['restaurants', 'bars', 'activities', 'cafés', 'gyms', 'pop-ups']}
    speed={80}
    erase={60}
    pause={900}
  />
</View>

          <Text style={styles.heroSub}>Find London venues by <Text style={{fontWeight:'700'}}>name</Text> or <Text style={{fontWeight:'700'}}>location</Text> and send a formatted collab proposal.</Text>

          {/* Search pill */}
          <View style={styles.searchRow}>
            <View style={styles.searchBox}>
              <Ionicons name="search" size={18} color={THEME.textMut} style={{marginRight:8}} />
             <TextInput
  style={styles.searchInput}
  placeholder={mode === 'name' ? 'Search venue name…' : 'Search borough…'}
  placeholderTextColor={THEME.textMut}
  value={q}
  onChangeText={setQ}
  numberOfLines={1}            // NEW: keep on one line
  ellipsizeMode="tail"         // NEW: trim with …
  autoCorrect={false}          // optional but tidy
  autoCapitalize="none"        // optional but tidy
  returnKeyType="search"       // optional
/>

            </View>
            <TouchableOpacity
              style={[styles.toggleBtn, mode==='name' && { backgroundColor: THEME.accent, borderColor: THEME.accentLine }]}
              onPress={() => setMode('name')}
            >
              <Text style={[styles.toggleText, mode==='name' && { color: THEME.text } ]}>Name</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[styles.toggleBtn, mode==='location' && { backgroundColor: THEME.accent, borderColor: THEME.accentLine }]}
              onPress={() => setMode('location')}
            >
              <Text style={[styles.toggleText, mode==='location' && { color: THEME.text } ]}>Location</Text>
            </TouchableOpacity>
          </View>
        </LinearGradient>

        {/* Results */}
        <ScrollView contentContainerStyle={styles.content}>
    {loading ? (
  <View style={{paddingTop:28}}><ActivityIndicator size="large" color={THEME.pine} /></View>
) : results.length === 0 ? (
  <View style={styles.emptyCard}>
    <View style={styles.tipsRow}>
      <Text style={styles.tip}>Example: “Café 23” → “Cafe”</Text>
      <Text style={styles.tip}>Borough: “Hackney”, “Hampstead”</Text>
    </View>

    <View style={styles.featuredHeaderRow}>
      <Text style={styles.featuredTitle}>Discover unclaimed picks</Text>
      <TouchableOpacity onPress={() => fetchFeatured(20)}>
        <Text style={styles.refreshLink}>Refresh</Text>
      </TouchableOpacity>
    </View>

    {loadingFeatured ? (
      <View style={{ paddingVertical: 18 }}>
        <ActivityIndicator size="small" color={THEME.text} />
      </View>
    ) : featured.length === 0 ? (
      <Text style={styles.featuredEmpty}>No featured venues right now.</Text>
    ) : (
      <ScrollView
        ref={featuredRef}
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={styles.featuredScroller}
      >
        {featured.map((v, idx) => (
          <TouchableOpacity
            key={`${v.Name}-${idx}`}
            activeOpacity={0.9}
            style={styles.featuredCard}
            onPress={() => onRequest(v)}
          >
            <View style={styles.featuredTopRow}>
              <Text style={styles.featuredName} numberOfLines={1}>{v.Name}</Text>
            </View>
            <Text style={styles.featuredLoc} numberOfLines={1}>{v.Location || 'London'}</Text>

            <View style={styles.featuredCtaRow}>
              <Text style={styles.featuredCtaText}>Propose collab</Text>
              <Ionicons name="arrow-forward-circle" size={18} color={THEME.text} />
            </View>
          </TouchableOpacity>
        ))}
      </ScrollView>
    )}


{/* SECOND rolling banner (reverse) */}
{loadingFeatured2 ? (
  <View style={{ paddingVertical: 18 }}>
    <ActivityIndicator size="small" color={THEME.text} />
  </View>
) : featured2.length === 0 ? null : (
  <ScrollView
    ref={featuredRef2}
    horizontal
    showsHorizontalScrollIndicator={false}
    contentContainerStyle={[styles.featuredScroller, { marginTop: 12 }]}
  >
    {featured2.map((v, idx) => (
      <TouchableOpacity
        key={`second-${v.Name}-${idx}`}
        activeOpacity={0.9}
        style={styles.featuredCard}
        onPress={() => onRequest(v)}
      >
        <View style={styles.featuredTopRow}>
          <Text style={styles.featuredName} numberOfLines={1}>{v.Name}</Text>
        </View>
        <Text style={styles.featuredLoc} numberOfLines={1}>{v.Location || 'London'}</Text>
        <View style={styles.featuredCtaRow}>
          <Text style={styles.featuredCtaText}>Propose collab</Text>
          <Ionicons name="arrow-back-circle" size={18} color={THEME.text} />
        </View>
      </TouchableOpacity>
    ))}
  </ScrollView>
)}


  </View>
) : (
  /* your current results.map(...) block unchanged */
  results.map((v, i) => (
    <View key={`${v.Name}-${i}`} style={styles.card}>
      <View style={styles.cardTop}>
        <Text style={styles.venueName}>{v.Name}</Text>
      </View>
      <View style={styles.rowBetween}>
        <Text style={[styles.locationText, { fontWeight: '400' }]}>
          {v.Location || 'London'}
        </Text>
      </View>
      <View style={styles.actionsRow}>
        <TouchableOpacity
          style={[styles.ctaBtn, styles.ctaBtnTight, styles.glassYellow]}
          onPress={() => onRequest(v)}
        >
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <Ionicons name="paper-plane-outline" size={18} color={THEME.text} style={{ marginRight: 6 }} />
            <Text style={styles.ctaBtnText}>Request Collab</Text>
          </View>
        </TouchableOpacity>
      </View>
    </View>
  ))
)}

        </ScrollView>

{/* Sticky footer */}

{/* Footer (exact style/markup as your reference) */}
{/* Footer (replicated from homepage footer) */}
<View style={styles.footer}>
  <TouchableOpacity
    style={styles.footerIcon}
    onPress={() => navigation.navigate('Homepage')}
  >
    <Ionicons name="home" size={24} color="black" />
  </TouchableOpacity>

  <TouchableOpacity
    style={styles.footerIcon}
    onPress={() => navigation.navigate('UserCollabDashboard')}
  >
    <Ionicons name="qr-code" size={24} color="black" />
  </TouchableOpacity>

  <TouchableOpacity
    style={styles.footerIcon}
    onPress={() => navigation.navigate('CollabCalendar')}
  >
    <Ionicons name="calendar" size={24} color="black" />
  </TouchableOpacity>

  <TouchableOpacity
    style={styles.footerIcon}
    onPress={() => navigation.navigate('UserActivityFeed')}
  >
    <Ionicons name="chatbox-ellipses-outline" size={24} color="black" />
  </TouchableOpacity>


    <TouchableOpacity
      style={styles.footerIcon}
      onPress={() => navigation.navigate('UserRecapPage')}
    >
      <Ionicons name="person" size={24} color="black" />
    </TouchableOpacity>

</View>

        
      </SafeAreaView>

      {/* Date modal */}
      <Modal visible={showDateModal} transparent animationType="fade" onRequestClose={() => setShowDateModal(false)}>
        <View style={styles.modalOverlay}>
          <View style={styles.modalCard}>
            <View style={styles.modalHeader}>
              <Text style={styles.modalTitle}>Pick a date & time</Text>
              <TouchableOpacity onPress={() => setShowDateModal(false)}><Ionicons name="close" size={22} color={THEME.text} /></TouchableOpacity>
            </View>
            <Text style={styles.modalSub}>Your request to <Text style={{fontWeight:'800'}}>{activeVenue?.Name}</Text> will include this slot.</Text>
            {Platform.OS === 'web' ? (
              <input
                type="datetime-local"
                value={dt}
                onChange={e => setDt(e.target.value)}
                style={{ width:'80%', padding:12, borderRadius:12, borderWidth:1, borderColor:THEME.line, outline:'none', backgroundColor:'#fff', color:THEME.text, marginTop: 5 }}
              />
            ) : (
              <TextInput
                value={dt}
                onChangeText={setDt}
                placeholder="YYYY-MM-DDTHH:mm"
                placeholderTextColor={THEME.textMut}
                style={styles.fallbackInput}
              />
            )}
            <View style={styles.modalActions}>
              <TouchableOpacity style={styles.ghostBtn}><Text style={styles.ghostBtnText} onPress={() => setShowDateModal(false)}>Cancel</Text></TouchableOpacity>
              <TouchableOpacity style={styles.ctaBtn} onPress={onContinue}><Text style={styles.ctaBtnText}>Continue</Text></TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      {/* Confirm modal */}
      <Modal visible={showConfirmModal} transparent animationType="fade" onRequestClose={() => setShowConfirmModal(false)}>
        <View style={styles.modalOverlay}>
          <View style={styles.modalCard}>
            <View style={styles.modalHeader}>
              <Text style={styles.modalTitle}>One more thing…</Text>
              <TouchableOpacity onPress={() => setShowConfirmModal(false)}><Ionicons name="close" size={22} color={THEME.text} /></TouchableOpacity>
            </View>
            <View style={styles.hr} />
            <Text style={styles.modalBodyText}><Text style={{fontWeight:'800'}}>This venue isn’t on collabbay just yet.</Text> Good news, you can nominate them.</Text>
            <View style={{marginTop:6}}>
              <Text style={styles.bullet}>1• Hard work's done. We’ll open a pre-filled email with your collab request drafted up.</Text>
              <Text style={styles.bullet}>2• Just for sending a request, <Text style={{fontWeight:'800'}}>you get 50 collabbay credits</Text>... More revealed on this soon.</Text>
              <Text style={styles.bullet}>3• Oh, and besides your collab, if the venue joins the community, <Text style={{fontWeight:'800'}}>you get £40</Text>.</Text>
            </View>
            <View style={styles.hr} />
            <View style={styles.modalActions}>
              <TouchableOpacity style={styles.ghostBtn} onPress={() => setShowConfirmModal(false)}><Text style={styles.ghostBtnText}>Quit</Text></TouchableOpacity>
              <TouchableOpacity style={styles.ctaBtn} onPress={onConfirmSend}><Text style={styles.ctaBtnText}>Request Collab</Text></TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    </View>
  );
}

function maskEmail(e){ if(!e) return '—'; const [u,dom]=e.split('@'); if(!dom) return e; const m = u.length<=2?u[0]+'…':u.slice(0,2)+'…'+u.slice(-1); return `${m}@${dom}`; }

const styles = StyleSheet.create({
safe: { flex:1, width:'100%', maxWidth:960, alignSelf:'center', paddingHorizontal:16 },
  hero: {
    borderBottomLeftRadius: 28, borderBottomRightRadius: 28,
    paddingHorizontal:16, paddingTop:12, paddingBottom:18, marginLeft: 10, marginRight: 10
  },
  heroTop: { flexDirection:'row', alignItems:'center', justifyContent:'space-between' },
  backBtn: { padding:8, borderRadius:12, backgroundColor: THEME.accent },
  loginBtn: { paddingHorizontal: 14, paddingVertical: 8, borderRadius: 12, borderWidth:1, borderColor: THEME.accentLine, backgroundColor: THEME.accent },
  loginBtnText: { color: THEME.text, fontWeight:'800' },
  loginPill: { backgroundColor: '#F6F7EC', borderRadius: 999, paddingHorizontal:12, paddingVertical:8, borderWidth:1, borderColor:'#E6EAD9' },
  loginPillText: { color: THEME.textMut, fontSize:10 },

  heroTitle: { fontSize:24, fontWeight:'800', color:'#FFFFFF', marginTop:12 },
  heroSub: { fontSize:13, color:'#E5EFEA', marginTop:6 },

  searchRow: { flexDirection:'row', alignItems:'center', gap:8, marginTop:14 },
searchBox: {
  flex:1,
  flexDirection:'row',
  alignItems:'center',
  backgroundColor:'#ECF1EA',
  borderRadius:22,
  paddingHorizontal:12,
  paddingVertical:10,
  borderWidth:1,
  borderColor:'#DAE6DC',
  overflow:'hidden',   // NEW: clip any stray overflow
},

searchInput: {
  flex: 1,
  color: THEME.text,
  minWidth: 0,     // NEW: allow flex child to shrink in a row
  fontSize: 15,    // NEW: consistent sizing (prevents wrap weirdness)
  lineHeight: 18,  // NEW: keeps placeholder vertically tidy
},

  toggleBtn: {
    paddingHorizontal: 12, paddingVertical: 10, borderRadius: 20,
    borderWidth:1, borderColor: THEME.line, backgroundColor: THEME.surface
  },
  toggleText: { fontWeight:'800', color: THEME.textMut },

  content: { paddingHorizontal:16, paddingVertical:18, gap:12 },

  emptyCard: {
    backgroundColor: THEME.surface, borderRadius: 18, padding: 18,
    borderWidth:1, borderColor: THEME.line
  },
  emptyTitle: { fontWeight:'800', fontSize:16, color: THEME.text },
  emptySub: { color: THEME.textMut, marginTop:6, marginBottom:10 },
  tipsRow: { flexDirection:'row', flexWrap:'wrap', gap:8 },
  tip: { backgroundColor: THEME.subtle, borderColor: THEME.line, borderWidth:1, borderRadius: 999, paddingHorizontal:12, paddingVertical:6, color: THEME.textMut, fontSize:12 },

card: {
   backgroundColor: THEME.surface,
   borderRadius: 16,
   padding: 14,
   borderWidth: 1,
   borderColor: THEME.line,
   shadowColor: '#0A1B15',
   shadowOpacity: 0.05,
   shadowRadius: 10,
   shadowOffset: { width: 0, height: 2 },
   elevation: 2,},

  cardTop: { flexDirection:'row', alignItems:'center', justifyContent:'space-between' },
venueName: { fontWeight:'900', fontSize:21, color: THEME.text, letterSpacing: 0.2 },
locationText: { color: THEME.textMut, fontWeight:'300', fontSize:12 },
actionsRow: { flexDirection:'row', justifyContent:'flex-end', gap:10, marginTop:10 },
badge: { backgroundColor: THEME.accent, paddingHorizontal:10, paddingVertical:4, borderRadius:999, borderWidth:1, borderColor: THEME.accentLine },
badgeText: { fontWeight:'900', color: THEME.text, fontSize:12, letterSpacing:0.2 },
  badge: { backgroundColor: THEME.accent, paddingHorizontal:10, paddingVertical:4, borderRadius:999, borderWidth:1, borderColor: THEME.accentLine },
  badgeText: { fontWeight:'800', color: THEME.text, fontSize:12 },

  rowBetween: { flexDirection:'row', alignItems:'center', justifyContent:'space-between', marginTop:6 },
  locationText: { color: THEME.textMut, fontWeight:'400' },

  metaRow: { flexDirection:'row', flexWrap:'wrap', alignItems:'center', gap:8, marginTop:10 },
  infoPill: {
    flexDirection:'row', alignItems:'center', gap:6,
    backgroundColor: THEME.subtle, borderWidth:1, borderColor: THEME.line, borderRadius: 999, paddingHorizontal:10, paddingVertical:6
  },
  infoPillText: { color: THEME.textMut, fontWeight:'700', fontSize:12 },
  infoPillBrand: { backgroundColor:'#FFF9C7', borderColor: THEME.accentLine, borderWidth:1, borderRadius: 999, paddingHorizontal:10, paddingVertical:6 },
  infoPillBrandText: { color: THEME.text, fontWeight:'800', fontSize:12 },

  actionsRow: { flexDirection:'row', justifyContent:'flex-end', gap:10, marginTop:12 },
  ghostBtn: { paddingHorizontal: 14, paddingVertical: 10, borderRadius: 12, borderWidth: 1, borderColor: THEME.line, backgroundColor: THEME.surface },
  ghostBtnText: { fontWeight:'800', color: THEME.text },
  ctaBtn: { paddingHorizontal:16, paddingVertical:12, borderRadius: 20, backgroundColor: THEME.accent, borderWidth:1, borderColor: THEME.accentLine },
  ctaBtnText: { fontWeight:'900', color: THEME.text },

  modalOverlay: { flex:1, backgroundColor:'rgba(0,0,0,.4)', alignItems:'center', justifyContent:'center', padding:16 },
  modalCard: { width:'100%', maxWidth:560, backgroundColor: THEME.surface, borderRadius:16, padding:16, borderWidth:1, borderColor: THEME.line },
  modalHeader: { flexDirection:'row', alignItems:'center', justifyContent:'space-between' },
  modalTitle: { fontSize:18, fontWeight:'800', color: THEME.text },
  modalSub: { marginTop:6, color: THEME.textMut },
  modalActions: { flexDirection:'row', justifyContent:'flex-end', gap:10, marginTop:12 },
  hr: { height:1, backgroundColor: THEME.line, marginVertical:10 },
  modalBodyText: { color: THEME.text },
  bullet: { color: THEME.textMut, marginVertical:3 },
glassYellow: {
  backgroundColor: 'rgba(255, 223, 13, 0.72)', // #FFDF0D with alpha
  borderColor: '#E6D84F',
  borderWidth: 1,
  // web-only frosting:
  ...(Platform.OS === 'web' ? { backdropFilter: 'blur(8px)' } : {}),
},
ctaBtnTight: {
  paddingHorizontal: 16,
  paddingVertical: 10,
  borderRadius: 20,
},
featuredHeaderRow: {
  marginTop: 14,
  marginBottom: 10,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between'
},
featuredTitle: {
  fontSize: 16,
  fontWeight: '800',
  color: THEME.text
},
refreshLink: {
  fontSize: 12,
  fontWeight: '800',
  color: THEME.textMut,
  textDecorationLine: 'underline'
},
featuredEmpty: {
  color: THEME.textMut,
  marginTop: 8
},
featuredScroller: {
  paddingVertical: 4,
  gap: 12 // works on web RNW; otherwise simulate with margins on cards
},
featuredCard: {
  width: 220,                   // ~30% feel on 960 container
  backgroundColor: THEME.surface,
  borderRadius: 18,
  padding: 12,
  borderWidth: 1,
  borderColor: THEME.line,
  shadowColor: '#0A1B15',
  shadowOpacity: 0.06,
  shadowRadius: 10,
  shadowOffset: { width: 0, height: 2 },
  elevation: 2,
  marginRight: 12,              // fallback if gap not supported
  ...(Platform.OS === 'web' ? { backdropFilter: 'blur(4px)' } : {})
},
featuredTopRow: {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 6
},
featuredName: {
  fontSize: 15,
  fontWeight: '900',
  color: THEME.text
},
featuredLoc: {
  fontSize: 12,
  color: THEME.textMut,
  marginBottom: 10
},
featuredCtaRow: {
  marginTop: 'auto',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between'
},
featuredCtaText: {
  fontSize: 12,
  fontWeight: '900',
  color: THEME.text
},

typeLine: { flexDirection: 'row', alignItems: 'center', marginTop: 6, flexWrap: 'wrap' },

heroSubStatic: {
  fontSize: 21,        // larger
  fontWeight: '600',   // weight for "Search any"
  color: '#FFFFFF'     // white
},
footer: {
  flexDirection: 'row',
  justifyContent: 'space-around',
  position: 'sticky',     // web sticky like your reference
  bottom: 0,
  backgroundColor: 'white',
  left: 0,
  right: 0,
  paddingVertical: 10,
},
footerIcon: {
  alignItems: 'center',
},


footerLabel: {
  fontSize: 10,
  fontWeight: '800',
  color: THEME.text,
  opacity: 0.75,
},
footerIconActive: {
  // subtle highlight for current tab
  borderRadius: 12,
  paddingHorizontal: 8,
  paddingVertical: 4,
  backgroundColor: THEME.subtle,
  borderWidth: 1,
  borderColor: THEME.line,
},

typeText: {
  fontSize: 23,        // larger
  fontWeight: '800',   // heavier for the typewriter word
  color: '#FFFFFF',    // white
  marginLeft: 6
},

caret: {
  fontSize: 23,        // match size
  fontWeight: '900',
  color: '#FFFFFF'
},

  fallbackInput: { width:'100%', backgroundColor:'#FAFAF8', color: THEME.text, borderRadius:12, borderWidth:1, borderColor: THEME.line, paddingHorizontal:12, paddingVertical:12 },
});
